'use strict';
const applyAttributes = require('./apply-attributes');
module.exports = function createChildElement(parentElement, tag, initialAttributes) {
	if (!parentElement || !tag) {
		throw new Error('invalid-args');
	}
	const element = parentElement.ownerDocument.createElement(tag);
	parentElement.appendChild(element);
	if (initialAttributes) {
		applyAttributes(element, initialAttributes);
	}
	return element;
};
